module["exports"] = [
  "Pan",
  "Pani"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/name/prefix.js
// module id = 1615
// module chunks = 1